/* Elegancecoque Luxe - menu de tri (utilise le <select name=sort_by> existant) */
(function(){
var doc=document;
function init(ctx){
 [].slice.call((ctx||doc).querySelectorAll('[data-lcs]')).forEach(function(box){
  if(box.__lcs){return;}box.__lcs=true;
  var btn=box.querySelector('[data-lcs-btn]'),label=box.querySelector('[data-lcs-label]'),sel=box.querySelector('select[data-lcf-sort]');
  var opts=[].slice.call(box.querySelectorAll('[data-lcs-opt]'));
  function open(v){box.classList.toggle('is-open',v);btn.setAttribute('aria-expanded',v?'true':'false');}
  btn.addEventListener('click',function(e){e.stopPropagation();open(!box.classList.contains('is-open'));});
  doc.addEventListener('click',function(e){if(!box.contains(e.target)){open(false);}});
  doc.addEventListener('keydown',function(e){if(e.key==='Escape'){open(false);}});
  opts.forEach(function(o){o.addEventListener('click',function(){
   var v=o.getAttribute('data-value');
   opts.forEach(function(x){x.setAttribute('aria-selected',x===o?'true':'false');});
   if(label){label.textContent=o.getAttribute('data-short');}
   open(false);
   if(sel&&sel.value!==v){sel.value=v;sel.dispatchEvent(new Event('change',{bubbles:true}));}
  });});
 });
}
if(doc.readyState==='loading'){doc.addEventListener('DOMContentLoaded',function(){init();});}else{init();}
doc.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
